export const leadsFilterSchema = [
  {
    label: "Status",
    field: "status",
    options: [
      { value: "New", label: "New" },
      { value: "Unassigned", label: "Unassigned" },
      { value: "Contacted", label: "Contacted" },
      { value: "Engaging", label: "Engaging" },
      { value: "Potential", label: "Potential" },
      { value: "Enrolled", label: "Enrolled" },
      { value: "Cold", label: "Cold" },
      { value: "Lost", label: "Lost" },
      { value: "Duplicate", label: "Duplicate" },
    ],
  },
];
